var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g2, _g3, _g4, _g5, _path12, _path13, _path14, _g6, _g7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEveInstructorList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 460 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M357.558 38.04a132.168 132.168 0 00-46.4-2.366 201.351 201.351 0 01-117.405-20.617 133.07 133.07 0 10-43.16 250.192c40.493-5.49 81.539 2.44 118.133 20.623a132.65 132.65 0 00188.14-88.468c16.665-71.152-28.099-142.949-99.308-159.364z",
    fill: "#e1f6fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200.182 176.84c-67.302 2.35-130.081 10.351-183.6 22.328a133.206 133.206 0 00133.487 66.081c40.492-5.49 81.538 2.44 118.132 20.623a132.652 132.652 0 00187.255-84.917c-65.797-18.112-156.066-27.58-255.274-24.115z",
    fill: "#c3edfd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.819 45.73H85.74a1.96 1.96 0 01-1.96-1.96V21.73a1.96 1.96 0 011.96-1.96h51.079a1.96 1.96 0 011.959 1.96v22.04a1.96 1.96 0 01-1.96 1.96zm-49.12-3.919h47.16V23.69h-47.16zM177.819 55.904H85.74a1.96 1.96 0 110-3.919h92.079a1.96 1.96 0 110 3.919zM177.819 66.505H85.74a1.96 1.96 0 010-3.919h92.079a1.96 1.96 0 010 3.92zM177.819 24.1H147.74a1.96 1.96 0 010-3.919h30.078a1.96 1.96 0 010 3.92zM177.819 34.701H147.74a1.96 1.96 0 010-3.919h30.078a1.96 1.96 0 110 3.92zM177.819 45.302H147.74a1.96 1.96 0 010-3.919h30.078a1.96 1.96 0 010 3.92z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M319.126 264.77h95l20.216-86.531a17.985 17.985 0 00-17.417-22.468h-71.8z",
    fill: "#92defc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.59 176.653a10.277 10.277 0 01-1.012-20.48c48.53-5.725 53.867-14.043 64.501-30.614a10.276 10.276 0 0117.296 11.1c-15.075 23.493-26.477 33.682-79.39 39.924a10.333 10.333 0 01-1.396.07z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M319.633 118.252c8.277-4.276 19.258-.515 27.001 3.18l.299.138 44.344 20.503.299.138a34.071 34.071 0 0119.28 26.965c2.258 23.453-3.902 49.408-13.621 71.12-11.34 25.33-34.42 17.376-63.161 4.161-12.113-5.6-20.545-15.867-32.657-21.467-28.123-13.096-47.664-12.062-35.142-38.081 11.917-24.76 30.294-50.249 53.358-66.657",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M266.276 184.908a52.154 52.154 0 00-4.613 24.812 39.443 39.443 0 00-21.775 4.304c-10.518 5.684-18.488 16.641-24.627 34.052a11.1 11.1 0 00-13.477 17.233 206.615 206.615 0 0129.8 6.286 11.643 11.643 0 002.375-4.577c4.677-17.911 10.416-28.813 17.057-32.402 4.261-2.303 9.934-2.006 17.885.035.031.057.066.113.098.17-7.215 9.96-13.472 24.265-18.86 43.06q9.184 3.583 18.062 7.99 1.75.87 3.535 1.688a168.915 168.915 0 0110.465-29.165c1.403-2.163 4.047-4.4 8.393-1.656a7.724 7.724 0 00.928.503 55.832 55.832 0 003.171 1.616c12.113 5.6 13.514 6.97 25.627 12.57a46.959 46.959 0 0011.402 3.557 11.765 11.765 0 002.461.377c25.63 3.243 53.156-13.557 63.052-35.065a182.582 182.582 0 005.324-12.764c-16.577-16.745-35.003-35.058-56.175-45.78-.277-.141-.568-.28-.853-.42-23.801-2.45-48.91-4.078-75.003-4.787a131.016 131.016 0 00-4.252 8.363z",
    fill: "#c2ddff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M285.315 202.409c17.115 2.482 31.674 4.376 47.396 11.96 3.689 2.482 8.344.815 10.633-4.22 5.225-11.5 10.494-22.973 15.923-34.379 1.892-3.948.48-9.384-3.433-11.41a114.864 114.864 0 00-46.449-12.786c-4.822-.08-9.921 2.46-11.342 5.85-4.813 11.635-10.476 22.804-16.134 34.046-2.441 4.865-.99 10.097 3.406 10.939",
    fill: "#308cfd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301.963 164.07c-1.696 3.877.365 7.9 4.752 8.873 4.386.973 10.885-1.493 12.669-5.803 1.783-4.308-1.4-8.637-6.015-9.1-4.615-.464-9.71 2.155-11.406 6.03",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M284.94 173.855a9.385 9.385 0 007.192 11.155l4.44 1.247a9.385 9.385 0 003.965-18.347l-4.44-1.245a9.385 9.385 0 00-11.156 7.19",
    fill: "#62a8fd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M318.068 191.606a116.666 116.666 0 01-12.11-2.49 10.276 10.276 0 115.193-19.885 92.59 92.59 0 0069.062-8.778 10.276 10.276 0 1110.25 17.813 113.384 113.384 0 01-72.395 13.34z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M339.378 187.222c-20.88.475-30.658-4.616-39.874-12.895a10.241 10.241 0 006.455 14.788 116.666 116.666 0 0012.11 2.49 113.384 113.384 0 0072.394-13.34 10.27 10.27 0 004.98-10.713c-13.073 14.046-33.016 19.147-56.065 19.67z",
    fill: "#94c4fe"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#62a8fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.776 189.16c-.434-2.798-10.565-1.228-10.132 1.57a5.126 5.126 0 0010.132-1.57M379.283 183.847c-.95-2.667-10.608.775-9.658 3.442a5.126 5.126 0 109.658-3.442M392.415 177.316c-1.266-2.533-10.436 2.051-9.17 4.583a5.126 5.126 0 109.17-4.583"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266.136 239.08l-.01.017z",
    fill: "#308cfd",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.931 260.77c-5.97-5.497-13.278-11.691-22.086-9.149-1.18.315-2.445.671-3.68 1.131a11.118 11.118 0 001.538 12.477 206.417 206.417 0 0129.974 6.243 11.626 11.626 0 002.282-4.454c4.677-17.911 10.416-28.813 17.057-32.402 4.261-2.303 9.934-2.006 17.885.035.031.057.066.112.097.169l-.034.049c3.538-4.893 7.029-10.429 20.273-10.761-6.057-2.819-21.012-3.72-21.48-3.728-24.249-1.098-36.082 20.267-41.826 40.39zM331.722 274.984a11.765 11.765 0 002.46.377c25.63 3.243 53.157-13.557 63.053-35.065a182.582 182.582 0 005.324-12.764c-3.898-3.938-7.9-7.962-12.015-11.954-12.485 12.78-28.956 46.705-53.324 41.742-10.655-2.17-23.283-13.28-37.251-17.872a19.026 19.026 0 00-21.195 6.754c-7.802 10.494-12.48 27.2-14.3 37.619 1.423.67 2.842 1.35 4.252 2.05q1.521.756 3.069 1.473a168.798 168.798 0 0110.349-28.83 5.352 5.352 0 017.527-2.316 55.739 55.739 0 005.022 2.659c12.113 5.6 13.514 6.97 25.627 12.57a46.959 46.959 0 0011.402 3.557z",
    fill: "#94c4fe"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.354 87.391a66.298 66.298 0 1075.852-55.111 66.297 66.297 0 00-75.852 55.111",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.693 68.93c8.896-17.63 28.4-29.217 49.409-25.89l3.46.548c25.507 4.04 42.802 28.68 38.628 55.034l-2.03 12.815c-3.219 20.323-21.775 34.272-41.445 31.156l-24.598-3.896a34.974 34.974 0 01-15.303-6.39 35.598 35.598 0 01-11.991-16.62c-4.095-11.63-5.27-28.646 3.87-46.758",
    fill: "#c2ddff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.176 55.803c20.398-5.106 53.96 4.654 66.217 14.247a49.258 49.258 0 013.9 13.228l4.464.707a4.387 4.387 0 013.647 5.02l-4.35 27.467a4.387 4.387 0 01-5.02 3.647l-3.067-.486c-6.136 15.776-21.883 25.775-38.399 23.16l-27.904-4.42c-13.295-2.22-20.034-13.522-20.034-13.522-1.86-7.91-1.623-22.056-.247-30.743 2.586-16.329 9.447-29.141 20.793-38.305",
    fill: "#fff3e1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.777 99.677a1.39 1.39 0 01-.185-.012l-2.872-.383a1.38 1.38 0 01-1.074-1.94l2.5-5.5a1.38 1.38 0 112.513 1.143l-1.73 3.807 1.028.137a1.38 1.38 0 01-.18 2.748zM343.234 110.932a32.494 32.494 0 01-6.411-.612c-10.027-2.025-13.95-6.905-14.111-7.111a1.38 1.38 0 112.172-1.703c.03.036 3.54 4.301 12.486 6.108a35.61 35.61 0 0014.965-.602 1.38 1.38 0 01.772 2.651 38.57 38.57 0 01-9.873 1.269zM366.235 83.285a1.376 1.376 0 01-.883-.32 12.867 12.867 0 00-7.978-2.979l-.335-.006a1.38 1.38 0 01.026-2.76h.026l.335.006a15.632 15.632 0 019.695 3.619 1.38 1.38 0 01-.886 2.44zM330.923 74.855a1.375 1.375 0 01-.473-.084l-.95-.347a9.006 9.006 0 00-6.628.166 1.38 1.38 0 01-1.076-2.542 11.756 11.756 0 018.652-.217l.949.347a1.38 1.38 0 01-.474 2.677z",
    fill: "#3687ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.678 90.205a3.515 3.515 0 004.023-2.922l.668-4.22a3.516 3.516 0 00-6.945-1.1l-.668 4.22a3.515 3.515 0 002.922 4.022M358.345 95.778a3.516 3.516 0 004.023-2.924l.668-4.219a3.516 3.516 0 10-6.945-1.1l-.668 4.22a3.516 3.516 0 002.922 4.023",
    fill: "#308cfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.633 47.472c-5.36-.849-16.525-1.817-22.77-.485a8.314 8.314 0 00-6.556 6.765 8.629 8.629 0 007.453 9.648 9.184 9.184 0 005.574-.847c2.464 3.422 7.138 6.157 12.793 7.053 9.023 1.429 17.122-2.367 18.09-8.48.968-6.112-5.561-12.225-14.584-13.654",
    fill: "#f9d534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.175 55.904a46.189 46.189 0 0139.99-13.267l3.46.548a46.379 46.379 0 0135.417 28.177 162.882 162.882 0 00-44.41-13.525 167.833 167.833 0 00-34.457-1.933",
    fill: "#62a8fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.379 89.162h-27.194A17.478 17.478 0 00362.31 71.37a17.559 17.559 0 00-17.64 13.478 11.342 11.342 0 00-5.35-1.561c.041-.4.088-.8.102-1.21a17.5 17.5 0 10-18.1 16.88q.31.01.62.01a17.52 17.52 0 0016.799-12.695 8.387 8.387 0 014.753 1.359l.728.472c-.002.049-.01.096-.012.146a17.52 17.52 0 0016.879 18.1q.313.01.626.011a17.46 17.46 0 0017.152-14.197h27.036zm-84.952 6.795a14.5 14.5 0 01.5-28.991q.256 0 .513.009a14.5 14.5 0 01-1.013 28.982zm50.162 3.507a14.5 14.5 0 11-9.896-25.105c.17 0 .342.002.513.008a14.5 14.5 0 019.383 25.097z",
    fill: "#2ec0fa"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.058 189.905l-46.038-41.222 57.216-16.07 56.83 52.75a1.82 1.82 0 01-1.189 3.163z",
    fill: "#92defc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.875 133.961l-51.959 12.976 7.66-65.016a8.723 8.723 0 015.594-7.346l33.675-12.761a8.92 8.92 0 0112.045 9.132z",
    fill: "#92defc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.036 135.722l-51.959 12.976 7.66-65.017a8.723 8.723 0 015.593-7.345l38.56-14.613a5.646 5.646 0 017.625 5.78z",
    fill: "#c3edfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.063 195.055l-46.043-46.372 52.142-14.372 59.033 53.811-59.463 8.817a6.62 6.62 0 01-5.67-1.884z",
    fill: "#60cffb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.272 153.444a.75.75 0 01-.505-.195l-10.197-9.235a.753.753 0 011.01-1.116l10.198 9.235a.753.753 0 01-.506 1.31z",
    fill: "#06adef"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.779,
    cy: 103.163,
    rx: 7.982,
    ry: 5.634,
    transform: "rotate(-81.554 221.78 103.163)",
    fill: "#2ec0fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.375 108.128c-.185 0-.367-.004-.544-.01-3.125-.123-4.12-1.28-4.405-2.23-.285-.95-.091-2.465 2.45-4.287a1.13 1.13 0 111.316 1.836c-1.457 1.045-1.629 1.713-1.603 1.801.027.089.539.552 2.33.623a23.287 23.287 0 0012.319-3.697c1.457-1.045 1.629-1.714 1.602-1.802-.02-.066-.324-.37-1.36-.532a1.13 1.13 0 11.352-2.232c2.201.347 2.94 1.342 3.172 2.115.285.95.091 2.464-2.45 4.286a22.894 22.894 0 01-6.566 3.044 23.838 23.838 0 01-6.613 1.085z",
    fill: "#06adef"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M410.07 164.654c-2.385 11.922-1.932 10.612-7.511 26.726-3.47 10.024-6.955 17.696-12.015 24.198-2.666 4.319-3.86 7.753-2.508 10.31 4.344 8.223 8.55 14.988 14.523 1.644 9.72-21.71 10.555-34.903 8.297-58.356a31.074 31.074 0 00-.786-4.522z",
    fill: "#94c4fe"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M415.126 260.77h-110.29a9.71 9.71 0 00-9.71 9.712v5.578a9.711 9.711 0 009.71 9.71h40.29v12.861a131.96 131.96 0 0020-4.23v-8.63h21.902a133.287 133.287 0 0028.098-18.843z",
    fill: "#60cffb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.126 264.932v-33.161a14 14 0 00-14-14H29.887a133.256 133.256 0 00120.707 47.478c.843-.114 1.688-.214 2.532-.317z",
    fill: "#92defc"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.396 158l28.865 107.631q3.853.427 7.69.632L86.806 120.3l-.003-.008-.006-.026a5.27 5.27 0 00-.633-1.258c-.008-.01-.018-.017-.025-.027a3.64 3.64 0 00-.458-.481c-.012-.011-.028-.019-.04-.03a3.655 3.655 0 00-.518-.371c-.026-.016-.057-.024-.084-.039a3.607 3.607 0 00-.563-.256c-.04-.014-.085-.017-.127-.03a3.632 3.632 0 00-.324-.077c-.078-.016-.152-.044-.231-.055l-.024-.002-.015-.003c-.08-.01-.159-.001-.239-.006a3.54 3.54 0 00-.451-.014h-.01l-.012.002a3.569 3.569 0 00-.5.083c-.062.013-.124.014-.186.03l-.01.004-.019.004a3.624 3.624 0 00-.608.234c-.017.008-.036.012-.053.02a3.647 3.647 0 00-.598.378c-.059.045-.106.103-.161.152a3.628 3.628 0 00-.35.331c-.034.04-.058.086-.09.127a5.011 5.011 0 00-.605 1.078c-.018.051-.023.107-.038.159a3.603 3.603 0 00-.126.526l-.001.024-.004.014-16.027 126.33q3.346 2.03 6.831 3.876l11.68-92.055 6.687 100.043q3.66 1.274 7.437 2.342z",
    fill: "#62a8fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.738 120.037l31.861 3.435a2.906 2.906 0 003.204-3.173l-2.855-29.037a2.906 2.906 0 00-3.76-2.488l-30.583 9.574z",
    fill: "#0373f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.908 130.717l-6.14.604-4.266-43.38 6.141-.603a4 4 0 014.372 3.59l3.483 35.417a4 4 0 01-3.59 4.372zM126.483 77.879l-24.581 2.417-.18-1.83a3.974 3.974 0 013.565-4.343l16.673-1.639a3.974 3.974 0 014.343 3.566l.18 1.829z",
    fill: "#62a8fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.023 172.576a2.543 2.543 0 01-.722-4.981l17.49-5.186 8.172-13.172a2.543 2.543 0 114.32 2.682l-8.682 13.993a2.544 2.544 0 01-1.438 1.097l-18.417 5.46a2.53 2.53 0 01-.723.107z",
    fill: "#c2ddff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#62a8fd",
    d: "M78.327 85.534l-5.784.569-9.433-21.702 5.784-.569 9.433 21.702z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21 61.864l70.13-6.895.64 6.507-68.684 6.753a1.453 1.453 0 00-1.303 1.588l1.706 17.352-6.507.64-1.848-18.798a6.538 6.538 0 015.867-7.147z",
    fill: "#62a8fd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.029,
    cy: 149.014,
    rx: 23.247,
    ry: 16.709,
    transform: "rotate(-5.616 86.03 149.014)",
    fill: "#62a8fd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.883,
    y: 142.441,
    width: 69.015,
    height: 13.076,
    rx: 4.47,
    transform: "rotate(174.384 86.39 148.979)",
    fill: "#308cfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05 142.734l-98.317 9.667a8 8 0 01-8.745-7.178L23.014 94.63a8 8 0 017.179-8.744l98.317-9.667 6.54 66.514z",
    fill: "#c2ddff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.886,
    y: 86.585,
    width: 24.7,
    height: 65.382,
    rx: 4,
    transform: "rotate(-95.616 69.236 119.277)",
    fill: "#308cfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21 142.522l-21.68 2.132-6.54-66.515 21.68-2.132a8 8 0 018.744 7.18l4.975 50.59a8 8 0 01-7.179 8.745z",
    fill: "#94c4fe"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e0eeff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.442,
    y: 133.774,
    width: 7.265,
    height: 4.359,
    rx: 1.49,
    transform: "rotate(174.384 100.074 135.954)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.597,
    y: 134.841,
    width: 7.265,
    height: 4.359,
    rx: 1.49,
    transform: "rotate(174.384 89.23 137.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.752,
    y: 135.907,
    width: 7.265,
    height: 4.359,
    rx: 1.49,
    transform: "rotate(174.384 78.385 138.086)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.289 65.05l-47.142 4.635a.993.993 0 01-1.085-.891l-1.143-11.618a.993.993 0 01.892-1.086l47.141-4.635a4.67 4.67 0 015.105 4.19l.423 4.3a4.67 4.67 0 01-4.191 5.105z",
    fill: "#308cfd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.736,
    y: 167.789,
    width: 27.606,
    height: 10.171,
    rx: 3.477,
    transform: "rotate(162.384 34.54 172.874)",
    fill: "#94c4fe"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.142,
    y: 94.36,
    width: 10.222,
    height: 10.222,
    rx: 2,
    transform: "rotate(-95.616 40.253 99.471)",
    fill: "#62a8fd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#62a8fd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.059,
    y: 113.237,
    width: 3.632,
    height: 12.35,
    rx: 1.242,
    transform: "rotate(174.384 41.875 119.412)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.834,
    cy: 129.172,
    r: 1.453
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.726,
    y: 132.339,
    width: 19.615,
    height: 5.085,
    rx: 1.738,
    transform: "rotate(174.384 129.533 134.882)",
    fill: "#62a8fd"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.976,
    cy: 192.468,
    rx: 18.89,
    ry: 4.987,
    fill: "#60cffb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56 169.875a6.619 6.619 0 00-5.08-2.366h-3.368l.199-2.103a1.676 1.676 0 00-1.67-1.82h-27.329a1.676 1.676 0 00-1.67 1.82l2.017 21.362a6.045 6.045 0 006.023 5.53h14.589a6.03 6.03 0 005.867-4.677h2.287a8.829 8.829 0 008.71-7.319l.879-5.016a6.619 6.619 0 00-1.455-5.41zm-3.471 4.549l-.878 5.016a3.838 3.838 0 01-3.786 3.18h-1.615v-1.325l.83-8.786h3.84a1.633 1.633 0 011.609 1.915z",
    fill: "#92defc"
  }))));
}

export default __webpack_public_path__ + "d1278065.svg";
export { SvgEveInstructorList as ReactComponent };